export const placeConstants = {
    GET_PLACES_SUCCESS: 'GET_PLACES_SUCCESS',
    GET_ALL_PLACES_SUCCESS: 'GET_ALL_PLACES_SUCCESS',

    GET_PLACES_FAILURE: 'GET_PLACES_FAILURE',
    GET_ALL_PLACES_FAILURE: 'GET_ALL_PLACES_FAILURE',
}
